import React from 'react';

import './styles/socials.scss';
import LangA from '../../i18n/LangA';

const Socials = () => {
  return (
    <div className="socials">
      <ul>
        <li>
          <LangA href="https://www.facebook.com/zerobounce/" target="_blank" rel="nofollow noopener noreferrer" title="ZeroBounce Facebook">
            <div id="socials_facebook" className="bg-facebook" />

            <span className="hidden">Facebook</span>
          </LangA>
        </li>

        <li>
          <LangA href="https://x.com/zerobounce1" target="_blank" rel="nofollow noopener noreferrer" title="ZeroBounce X">
            <div id="socials_twitter" className="bg-twitter" />

            <span className="hidden">Twitter</span>
          </LangA>
        </li>

        <li>
          <LangA
            href="https://www.linkedin.com/company/zerobounce-net"
            target="_blank"
            rel="nofollow noopener noreferrer"
            title="ZeroBounce LinkedIn"
          >
            <div id="socials_linkedin" className="bg-linkedin" />

            <span className="hidden">Linkedin</span>
          </LangA>
        </li>

        <li>
          <LangA
            href="https://www.youtube.com/channel/UCgtYUvzaIabFdEXAKxDVjYg/featured"
            target="_blank"
            rel="nofollow noopener noreferrer"
            title="ZeroBounce YouTube"
          >
            <div id="socials_youtube" className="bg-youtube" />
            <span className="hidden">Youtube</span>
          </LangA>
        </li>

        <li>
          <LangA
            href="https://www.instagram.com/zerobounce/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            title="ZeroBounce Instagram"
          >
            <div id="socials_instagram" className="bg-instagram" />

            <span className="hidden">Instagram</span>
          </LangA>
        </li>

        <li>
          <LangA href="https://zerobounce1.tumblr.com/" target="_blank" rel="nofollow noopener noreferrer" title="ZeroBounce Tumblr">
            <div id="socials_tumblr" className="bg-tumblr" />

            <span className="hidden">Tumblr</span>
          </LangA>
        </li>
      </ul>
    </div>
  );
};

export default Socials;
